import {Component} from '@angular/core';
/**
 * \@title Basic checkboxes
 */
export class CheckboxOverviewExample {static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'checkbox-overview-example',
  templateUrl: 'checkbox-overview-example.html',
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function CheckboxOverviewExample_tsickle_Closure_declarations() {
/** @type {?} */
CheckboxOverviewExample.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CheckboxOverviewExample.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
